import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const Block = ({ children, bgImage, bgColor, bgColorBw, shiftY }) => (
  <div style={{ position: "relative" }}>
    {console.log("bgImage", bgImage)}
    <div
      style={{
        background: bgImage,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: "-1",
        opacity: "1",
        minHeight: "300px !important",
        minWidth: "200px",
      }}
    ></div>
    <div
      style={{
        width: "100%",
        height: "100%",
        zIndex: "-1",
        background: bgColorBw,
        opacity: ".7",
        position: "absolute",
      }}
    ></div>
    <div
      style={{
        borderRadius: "50px",
        padding: "40px 20px",
        margin: "0 calc(10vw/2) 80px calc(10vw/2)",
        minHeight: "80vh",
        transform: "translateY(" + shiftY + ")",
        background: bgColor,
      }}
    >
      {children}
    </div>
  </div>
);

export default Block;
